// extracted by mini-css-extract-plugin
export default {"closeBtn":"G5oG6R9GJdVu9N6gIAw6","icon":"Xy0dI_P3kIZEd7UhS5K7"};